module.exports = __webpack_public_path__ + "static/bg03-d96398b06e36bb0c60ab3af9a35f4b27.jpg";